<template>
  <div class="footer">
    <div class="body_container">
        <el-row justify='center' align='middle' class="el-row">
            <el-col class="first_box" :span="12">
                <div class='footer_about'>
                    <div class='footer_header'>ABOUT THE WEBSITE</div>
                    <div class='footer_body'>
                        <div class='web_intro' v-html="web_intro"></div>
                    </div>
                    <div class='footer_header' style="margin-top:15px">QUICK LINKS</div>
                    <div class='footer_body'>
                        <span ><a href="#/infer_cell">Analyze</a> | <a href="#/search">Search</a> | <a href="#/browse">Browse</a> | <a href="#/document?id=1-7">Citations</a> | 
                        <a href="#/document?id=2-1">Tutorial</a> | <a href="#/document?id=1-8">Data Pravicy</a> | <a href="#/document?id=1-9">Updates</a></span>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div>
                    <div class='footer_header'>WEB VISITORS</div>
                    <div class='footer_body' v-html="visitor_link">  
                    </div>
                </div>
            </el-col>
            <el-col :span="6" class="last_box">
                <div>
                    <div class='footer_header'>ABOUT US</div>
                    <div class='footer_body'>
                        <div class='ind_info' v-html="ind_info"></div>
                        <a :href="logo.link" target="_blank"><img class="link_img" :src="logo.url"/></a>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row justify='center' align='middle' class="el-row">
            <el-col class="footer-copyright">
                {{copyright}}
            </el-col>
        </el-row>
    </div>
  </div>
</template>

<script>
import pmglab_logo from '@/assets/img/pmglab_logo_rev.png';
export default {
  name: 'sx_footer',
  data:function(){
        return { 
            links: [
                {name:'KGG',url:'http://pmglab.top/kgg'},
                {name:'KGGSeq',url:'http://pmglab.top/kggseq'},
                {name:'KGGSEE',url:'http://pmglab.top/kggsee'}
            ],
            ind_info:
                'Precision Medicine Genomics Laboratory</br>\
                Zhongshan School of Medicine</br>\
                Sun Yat-sen University',
            copyright:
                'Copyright © 2021 All rights reserved by Precision Medicine Genomics Laboratory',
            logo:{url:pmglab_logo,
                link:'https://pmglab.top/'},
            web_intro:'PCGA (Phenotype-Cell-Gene Association) provides easy access to comprehensively explore the asscoiated tissue/cell types and genes of complex phenotypes. \
            The website had included 54 tissues, 6,598 single cell types and 1,588 unique phenotypes. <br> ',
            
            visitor_link:'<a href="https://www.revolvermaps.com/livestats/5e99wi6w787/"><img src="//rf.revolvermaps.com/h/m/a/0/ff0000/124/10/5e99wi6w787.png" width="220" height="110" alt="Map" style="border:0;"></a>'
        }
    }
}
</script>
<!--
    The details are described in \
            <a type="info" href="https://www.biorxiv.org/content/10.1101/2020.11.18.388488v1" target="_blank">A global overview of single-cell type selectivity and pleiotropy in complex diseases and traits. (bioRxiv)</a>',
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
    height: 250px;
    position: relative;
    z-index: 1000;
}

.el-row{
  /* height: 100%; */
  display:flex;
  align-items:top;
  justify-content: left;
  padding-top: 30px;
}


.link_img{
    height: 45px;
    margin-top: 10px;
}

.web_intro{
    font-size: 14px;
}

.footer-copyright{
    text-align:center;
    font-size: 14px;
}

.first_box{
    justify-content: left;
}
.last_box{
    justify-content: right;
}

.footer_header{
    font-size: 16px;
    font-weight: bold;
}
.footer_body{
    font-size: 14px;
    padding-top: 10px;
}
.footer_about{
    padding-right: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/footer.vue